import { render, staticRenderFns } from "./AboutUsPgHeader.vue?vue&type=template&id=4f203376&scoped=true&"
import script from "./AboutUsPgHeader.vue?vue&type=script&lang=js&"
export * from "./AboutUsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPgHeader.vue?vue&type=style&index=0&id=4f203376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f203376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
